import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'QuantumFiberTheme',
  code: 'quantumfiber',
  colors: {
    headerBackground: '#fff',
    headerText: '#212529',
    headerBorder: '#e0e7e9',
    background: '#FFFFFF',
    footerBackground: '#fff',
    footerText: '#000',
    footerBorder: 'transparent',
    footerGradient:
      'to right, #503296 0%, #7b8ee1 15%, #7b8ee1 40%, #38c6f4 40%',
    progressBar: '#0047bb',
  },
  logoSize: {
    width: '156px',
    height: '48px',
  },
  baseColors: {
    link: '#0047bb',
    cta: '#0047bb',
    hover: '#0047bb',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const QuantumFiberTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
